import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const TachographsTypes = ({ form, tachographsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Тахограф">
      {getFieldDecorator('tachograph_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите тахограф"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {tachographsTypes &&
            tachographsTypes.map(type => (
              <Option
                key={type.tachographKey}
                value={type.tachographKey}
                label={type.tachographName}
              >
                {type.tachographName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(TachographsTypes, ['tachographsTypes']);
